import * as React from 'react';
import Group from '@material-ui/icons/ShoppingCart';
import { useTranslate } from 'react-admin';

import CardWithIcon from './CardWithIcon';

interface Props {
	value?: number;
}

const TotalActiveTraineesCard = (props: Props) => {
	const { value } = props;
	const translate = useTranslate();
	return (
		<CardWithIcon
			to="/trainees"
			icon={Group}
			title={translate('TOTAL_ACTIVE_TRAINEES')}
			subtitle={value || '---'}
		/>
	);
};

export default TotalActiveTraineesCard;
